//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["localIP","numAdapters","adapters"],"GetSearchedAdapters",{},1,0],[["numInstances","ownerParts","instanceName","serverIP","localIP","deviceName","deviceScription","majorRevision","minorRevision","vendorID","deviceType","productCode"],"GetInstanceInfoes",{},0,0],[["ownerParts","instanceName","serverIP","localIP","deviceName","deviceScription","majorRevision","minorRevision","vendorID","deviceType","productCode"],"SetInstanceInfoes",{},11,0],[["instanceServerIP","ownerPart","numConnections","connectionInfos"],"GetInstanceConnections",{},2,0],[["instanceServerIP","ownerPart","connectionInfos"],"SetInstanceConnections",{},3,0],[["instanceServerIP","ownerPart","connectionName","numPath","pathContent"],"GetInstanceConnectionPath",{},3,0],[["instanceServerIP","ownerPart","connectionName","pathContent"],"SetInstanceConnectionPath",{},4,0],[["instanceServerIP","ownerPart","connectionName","numTags","signals"],"GetConnectionTags",{},3,0],[["instanceServerIP","ownerPart","connectionName","signals"],"SetConnectionTags",{},4,0]],[]];
SPLM.Mechatronics.EtherNetIPClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.EtherNetIPClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.EtherNetIPClientBuilder.Adapter = class{
    constructor(vendorID,deviceType,productCode,revision,majorRevision,minorRevision,status,serialNumber,productName,serverIP){
        this.vendorID=vendorID;this.deviceType=deviceType;this.productCode=productCode;this.revision=revision;this.majorRevision=majorRevision;this.minorRevision=minorRevision;this.status=status;this.serialNumber=serialNumber;this.productName=productName;this.serverIP=serverIP;}
    get Vendorid(){return this.vendorID}
    set Vendorid(val){this.vendorID = val}
    get Devicetype(){return this.deviceType}
    set Devicetype(val){this.deviceType = val}
    get Productcode(){return this.productCode}
    set Productcode(val){this.productCode = val}
    get Revision(){return this.revision}
    set Revision(val){this.revision = val}
    get Majorrevision(){return this.majorRevision}
    set Majorrevision(val){this.majorRevision = val}
    get Minorrevision(){return this.minorRevision}
    set Minorrevision(val){this.minorRevision = val}
    get Status(){return this.status}
    set Status(val){this.status = val}
    get Serialnumber(){return this.serialNumber}
    set Serialnumber(val){this.serialNumber = val}
    get Productname(){return this.productName}
    set Productname(val){this.productName = val}
    get Serverip(){return this.serverIP}
    set Serverip(val){this.serverIP = val}
};

SPLM.Mechatronics.EtherNetIPClientBuilder.Connection = class{
    constructor(connectionName,nTriggerType,nRpi,nTransportType,nTimeourMultipiler,nO2TSize,nO2TConnectionType,nO2TConnectionPriority,nO2TFixedVariable,nO2TTransferFormat,nT2OSize,nT2OConnectionType,nT2OConnectionPriority,nT2OFixedVariable,nT2OTransferFormat){
        this.connectionName=connectionName;this.nTriggerType=nTriggerType;this.nRpi=nRpi;this.nTransportType=nTransportType;this.nTimeourMultipiler=nTimeourMultipiler;this.nO2TSize=nO2TSize;this.nO2TConnectionType=nO2TConnectionType;this.nO2TConnectionPriority=nO2TConnectionPriority;this.nO2TFixedVariable=nO2TFixedVariable;this.nO2TTransferFormat=nO2TTransferFormat;this.nT2OSize=nT2OSize;this.nT2OConnectionType=nT2OConnectionType;this.nT2OConnectionPriority=nT2OConnectionPriority;this.nT2OFixedVariable=nT2OFixedVariable;this.nT2OTransferFormat=nT2OTransferFormat;}
    get Connectionname(){return this.connectionName}
    set Connectionname(val){this.connectionName = val}
    get Ntriggertype(){return this.nTriggerType}
    set Ntriggertype(val){this.nTriggerType = val}
    get Nrpi(){return this.nRpi}
    set Nrpi(val){this.nRpi = val}
    get Ntransporttype(){return this.nTransportType}
    set Ntransporttype(val){this.nTransportType = val}
    get Ntimeourmultipiler(){return this.nTimeourMultipiler}
    set Ntimeourmultipiler(val){this.nTimeourMultipiler = val}
    get No2tsize(){return this.nO2TSize}
    set No2tsize(val){this.nO2TSize = val}
    get No2tconnectiontype(){return this.nO2TConnectionType}
    set No2tconnectiontype(val){this.nO2TConnectionType = val}
    get No2tconnectionpriority(){return this.nO2TConnectionPriority}
    set No2tconnectionpriority(val){this.nO2TConnectionPriority = val}
    get No2tfixedvariable(){return this.nO2TFixedVariable}
    set No2tfixedvariable(val){this.nO2TFixedVariable = val}
    get No2ttransferformat(){return this.nO2TTransferFormat}
    set No2ttransferformat(val){this.nO2TTransferFormat = val}
    get Nt2osize(){return this.nT2OSize}
    set Nt2osize(val){this.nT2OSize = val}
    get Nt2oconnectiontype(){return this.nT2OConnectionType}
    set Nt2oconnectiontype(val){this.nT2OConnectionType = val}
    get Nt2oconnectionpriority(){return this.nT2OConnectionPriority}
    set Nt2oconnectionpriority(val){this.nT2OConnectionPriority = val}
    get Nt2ofixedvariable(){return this.nT2OFixedVariable}
    set Nt2ofixedvariable(val){this.nT2OFixedVariable = val}
    get Nt2otransferformat(){return this.nT2OTransferFormat}
    set Nt2otransferformat(val){this.nT2OTransferFormat = val}
};

SPLM.Mechatronics.EtherNetIPClientBuilder.SignalEx = class{
    constructor(name,strDataType,eIOType,strAddress){
        this.name=name;this.strDataType=strDataType;this.eIOType=eIOType;this.strAddress=strAddress;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Strdatatype(){return this.strDataType}
    set Strdatatype(val){this.strDataType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Straddress(){return this.strAddress}
    set Straddress(val){this.strAddress = val}
};

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionTriggerType = Object.freeze({
    "Cyclic" : "Cyclic", "ChangeOfStatus" : "ChangeOfStatus", "Application" : "Application"});

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionTransportType = Object.freeze({
    "Unknow" : "Unknow", "ExclusiveOwner" : "ExclusiveOwner", "ListenOnly" : "ListenOnly", "InputOnly" : "InputOnly", "RedaundantOwner" : "RedaundantOwner"});

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionType = Object.freeze({
    "MultiCast" : "MultiCast", "PointToPoint" : "PointToPoint"});

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionPriority = Object.freeze({
    "Low" : "Low", "High" : "High", "Scheduled" : "Scheduled", "Urgent" : "Urgent"});

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionFixedVarible = Object.freeze({
    "Fixed" : "Fixed", "Varible" : "Varible"});

SPLM.Mechatronics.EtherNetIPClientBuilder.ConnectionTransferFormat = Object.freeze({
    "Unknow" : "Unknow", "BitRunIdle" : "BitRunIdle", "PureData" : "PureData", "IdleWithZeroLength" : "IdleWithZeroLength", "HeartBeat" : "HeartBeat"});

export default SPLM;